/* eslint-disable react/jsx-filename-extension */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { object, string } from "yup";

import Button from "components/lib/Shared/Button";
import { ChevronRightIcon } from "components/lib/Shared/Icons/sflIcons";
import SectionDescription from "components/lib/Shared/SectionDescription";
import ValidationError from "components/lib/Shared/ValidationError";
import { updateProfileState } from "state/slices/profileUpdate";

const officialProfileTypes = [
  { id: "applicant", title: "Applicant" },
  { id: "fullProfile", title: "Full Profile" },
  { id: "professional", title: "Professional" },
];

const SelectProfileType = ({ handleNextBtn }) => {
  const { profileType = "", electronicAddress } = useSelector(
    (state) => state.profileUpdateSlice
  );
  const profileUpdate = useSelector(
    (state) => state.profileUpdateSlice
  );
  const currentUser = useSelector((state) => state.userSlice);
  const dispatch = useDispatch();

  const handleSubmit = (formData) => {
    dispatch(updateProfileState(formData));
    handleNextBtn();
  };

  return (
    <Formik
      enableReinitialize
      initialValues={{ profileType }}
      validationSchema={object().shape({
        profileType: string().required("Profile type is required"),
      })}
      onSubmit={(values) => handleSubmit(values)}
    >
      {({ errors, touched, setFieldValue }) => {
        const handleChangeIdType = (e) => {
          setFieldValue("profileType", e.target.value);
        };

        return (
          <Form>
            <SectionDescription
              id="Step: 1 of 5"
              title="Select Profile Type"
              description="The information provided will be used for current and future application process."
            />
            {/* Users id types */}
            <div>
              <fieldset className="mt-4">
                <legend className="sr-only">Users Profile types</legend>
                <div className="space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10">
                  {officialProfileTypes.map(({ id, title }) => (
                    <div key={id} className="flex items-center">
                      <input
                        id={id}
                        onChange={handleChangeIdType}
                        value={title}
                        name="profileType"
                        type="radio"
                        defaultChecked={title === profileType}
                        className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                      />
                      <label
                        htmlFor={id}
                        className="block ml-3 text-sm font-medium text-gray-700"
                      >
                        {title}
                      </label>
                    </div>
                  ))}
                </div>
                <ValidationError
                  errors={errors}
                  touched={touched}
                  name="profileType"
                />
              </fieldset>
            </div>
            <div className="py-3 text-right float-right">
              <Button type="submit" postIcon={ChevronRightIcon}>
                Save and proceed
              </Button>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default SelectProfileType;
